import React from 'react';
import { DefaultRecordType } from 'rc-table/lib/interface';

export const ReportUnloadCell = (value: any, record: DefaultRecordType) => (
  <React.Fragment>{(record.entryWeight - record.departureWeight) / 1000}</React.Fragment>
);
